<template>
  <div class="prize">
    <div class="img">
      <span>很遗憾</span>
    </div>
    <main class="jiangpin">
      <div class="top_img">
        <img src="@/images/drawrule/prize_no.png" alt="" />
      </div>
      <div class="fot_text">
        <div>别灰心下次试试</div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.prize {
  box-sizing: border-box;
  padding: 15px;
  width: 260px;
  background: #ffffff;
  border-radius: 16px;
  .img {
    width: 100%;
    height: 44px;
    position: relative;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #333;
    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .jiangpin {
    text-align: center;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    .top_img {
      text-align: center;
      height: 122px;
      img {
        width: 102px;
        height: 100%;
      }
    }
    .fot_text {
      margin-top: 10px;
    }
  }
}
</style>
